import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShipments = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M23 6.5C23 6.4 23 6.4 22.9 6.3C22.9 6.2 22.8 6.2 22.8 6.2L11.8 0.2C11.7 0.1 11.5 0.1 11.3 0.2L0.3 6.2C0.2 6.2 0.2 6.3 0.2 6.3C0 6.3 0 6.4 0 6.5V17.5C0 17.7 0.1 17.9 0.3 17.9L11.3 23.9C11.4 23.9 11.5 24 11.5 24C11.5 24 11.7 24 11.7 23.9L22.7 17.9C22.9 17.8 23 17.6 23 17.5V6.5ZM11.5 1.1L21.5 6.5L17.6 8.6L7.5 3.3L11.5 1.1ZM11.5 11.9L1.5 6.5L6.4 3.8L16.5 9.2L11.5 11.9ZM1 7.3L11 12.8V22.7L1 17.2V7.3ZM12 22.7V12.8L17 10.1V13.5C17 13.8 17.2 14 17.5 14C17.8 14 18 13.8 18 13.5V9.5L22 7.3V17.2L12 22.7Z",
		fill: "#F5F4F3"
	})
});
export default SvgShipments;
